import React from 'react';
export function KnowledgeSection() {
  return <div className="bg-white py-12" data-id="element-146">
      <div className="max-w-7xl mx-auto px-4" data-id="element-147">
        <div className="mb-8" data-id="element-148">
          <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-149">
            Conhecimento
          </h2>
          <p className="text-gray-600" data-id="element-150">
            Transporte Marítimo e Infraestruturas de Conectividade
          </p>
          <button className="mt-4 bg-blue-900 text-white px-4 py-2 rounded text-sm font-semibold" data-id="element-151">
            Ver mais
          </button>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-152">
          <div className="relative h-64 rounded-lg overflow-hidden" data-id="element-153">
            <img src="https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=600" alt="Portos e Infraestruturas" className="w-full h-full object-cover" data-id="element-154" />
            <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-6 text-white" data-id="element-155">
              <h3 className="text-xl font-bold mb-2" data-id="element-156">
                Portos e Infraestruturas Portuárias
              </h3>
              <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-157">
                Explorar
              </button>
            </div>
          </div>
          <div className="relative h-64 rounded-lg overflow-hidden" data-id="element-158">
            <img src="https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?w=600" alt="Transporte Marítimo" className="w-full h-full object-cover" data-id="element-159" />
            <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-6 text-white" data-id="element-160">
              <h3 className="text-xl font-bold mb-2" data-id="element-161">
                Transporte Marítimo de Passageiros e Mercadorias
              </h3>
              <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-162">
                Explorar
              </button>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-163">
          {[{
          title: 'Pescas e Mar',
          image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600'
        }, {
          title: 'Portos e Infraestruturas',
          image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=600'
        }, {
          title: 'Recursos do Mar',
          image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=600'
        }, {
          title: 'Conhecimento e Investigação',
          image: 'https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=600'
        }].map((item, index) => <div key={index} className="relative h-48 rounded-lg overflow-hidden" data-id="element-164">
              <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-165" />
              <div className="absolute inset-0 bg-blue-900 bg-opacity-60 flex flex-col justify-end p-6 text-white" data-id="element-166">
                <h3 className="text-lg font-bold mb-2" data-id="element-167">{item.title}</h3>
                <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-168">
                  Explorar
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}